module.exports = __webpack_public_path__ + "assets/word_study_default.ed65c348.svg";